import { Controller } from "@hotwired/stimulus"

// The pay button stays locked until the terms checkbox is checked.
export default class extends Controller {
  static targets = ["checkbox", "submit"]

  connect() {
    this.toggle()
  }

  toggle() {
    this.submitTarget.disabled = !this.checkboxTarget.checked
  }
}
